<template>
	<div class="w1">
	<div  class="Thematic_wrapper"><!-- Thematic_wrapper -->
				<el-skeleton :rows="30" :loading="loadingMask" animated >
						
						<div  class="bulletin_wrap"><!-- bulletin_wrap -->
							<ul class="title1">
								<li class="L">看板</li>
								<li class="M"></li>
								<li class="R"></li>
							</ul>
							
								
							
							<dl v-if="kanbanList&&kanbanList[(kanbanPageNo-1)*2]" class="bulletin_box"><!-- bulletin_box -->
								<dt></dt>
								<dd>
									<div  class="bulletin_focus"><a @click="jumppush('/detail/'+kanbanList[(kanbanPageNo-1)*2].id+'?col='+sourcecol)" target="_blank">{{kanbanList[(kanbanPageNo-1)*2].title}}</a></div>
									<ul  class="bulletin_list">
										<li><a @click="jumppush('/detail/'+kanbanList[(kanbanPageNo-1)*2].id+'?col='+sourcecol)" target="_blank">{{kanbanList[(kanbanPageNo-1)*2].summary}}</a></li>
										<!-- <li><a href=""  >中央经济工作会定调，释放信号，新的一年更强调推动煤炭和新能源优化组合；原料用能不纳入能源消费总量控制；能耗“双控”向碳减排总量和强度“双控”转变。</a></li>
										<li><a href=""  >国家发改委明确加速精细化用能管理，推进能效低于基准水平的重点行业企业有序改造升级。</a></li>
										<li><a href=""  >工信部明确2022年重点抓好工业领域碳达峰，稳步推进产业绿色低碳转型。</a></li>
										<li><a href=""  >国资委部署落实中央企业双碳工作，重点推进钢铁、有色、石油石化、建筑、交通、建材领域节能降碳；探索央企利用林业碳汇资源合作。</a></li> -->
									</ul>
								</dd>
		<!--						<dd  class="editor"><img src="images/editor.png" width="145" height="200" alt=""/></dd>-->
							</dl><!-- /bulletin_box -->
							<div class="m_b1"></div>
							<dl v-if="kanbanList&&kanbanList[(kanbanPageNo-1)*2+1]" class="bulletin_box"><!-- bulletin_box -->
								<dt></dt>
								<dd>
									<div  class="bulletin_focus"><a @click="jumppush('/detail/'+kanbanList[(kanbanPageNo-1)*2+1].id+'?col='+sourcecol)" target="_blank">{{kanbanList[(kanbanPageNo-1)*2+1].title}}</a></div>
									<ul v-if="kanbanList[(kanbanPageNo-1)*2+1].summary" class="bulletin_list">
										<li><a @click="jumppush('/detail/'+kanbanList[(kanbanPageNo-1)*2+1].id+'?col='+sourcecol)" target="_blank">{{kanbanList[(kanbanPageNo-1)*2+1].summary}}</a></li>
									</ul>
								</dd>
							</dl><!-- /bulletin_box -->
	<!--						<div class="line2"></div>-->
							<div class="bulletin_footer"><!-- <R>责编：{{kanbanList[(kanbanPageNo-1)*2].author?kanbanList[(kanbanPageNo-1)*2].author:(kanbanList[(kanbanPageNo-1)*2+1]?kanbanList[(kanbanPageNo-1)*2+1].author:'')}}</R> --></div>
						</div><!-- /bulletin_wrap -->
						
						
						
						
						 					
						<div class="scrNews-box scrNews" id="J-lb"><!-- scrNews -->
							
							<div class="scrNews-nav-box" >
								<div class="scrNews-nav" id="J-lbn">
									<a href="javascript:void(0)" @click="preKBPage" class="cei-icon icon-pre2 prev"><img src="/images/icon_pre.png" /></a>
									<span><em id="J-lbcp">{{kanbanPageNo}}</em>/<em>{{kanbanPageTotal}}</em></span>
									<a href="javascript:void(0)" @click="nextKBPage" class="cei-icon icon-next2 next"><img src="/images/icon_next.png" /></a>
								</div>
							</div>
							
							<div class="scrNews-bd" id="scrNews">
								<div class="news">
									<div class="news-list">
										<ul>
											<li><a v-if="kanbanList&&kanbanList[(kanbanPagePre-1)*2]" @click="jumppush('/detail/'+kanbanList[(kanbanPagePre-1)*2].id+'?col='+sourcecol)" target="_blank">{{kanbanList[(kanbanPagePre-1)*2].title}}</a></li>
											<li><a v-if="kanbanList&&kanbanList[(kanbanPagePre-1)*2+1]" @click="jumppush('/detail/'+kanbanList[(kanbanPagePre-1)*2+1].id+'?col='+sourcecol)" target="_blank">{{kanbanList[(kanbanPagePre-1)*2+1].title}}</a></li>
										</ul>
									</div>
									<div class="news-list">
										<ul>
											<li><a v-if="kanbanList&&kanbanList[(kanbanPageNext-1)*2]" @click="jumppush('/detail/'+kanbanList[(kanbanPageNext-1)*2].id+'?col='+sourcecol)" target="_blank">{{kanbanList[(kanbanPageNext-1)*2].title}}</a></li>
											<li><a v-if="kanbanList&&kanbanList[(kanbanPageNext-1)*2+1]" @click="jumppush('/detail/'+kanbanList[(kanbanPageNext-1)*2+1].id+'?col='+sourcecol)" target="_blank">{{kanbanList[(kanbanPageNext-1)*2+1].title}}</a></li>
										</ul>
									</div>
								</div>
								<!-- <div class="news">
									<div class="news-list">
										<ul>
											<li><a href=""  >2中央经济工作会定调，释放信号，新的一年更强调推动煤炭和新能源优化组合；原料用能不纳入能源消费总量控制；能耗“双控”向碳减排总量和强度“双控”转变。</a></li>
											<li><a href=""  >国家发改委明确加速精细化用能管理，推进能效低于基准水平的重点行业企业有序改造升级。</a></li>
										</ul>
									</div>
									<div class="news-list">
										<ul>
											<li><a href=""  >中央经济工作会定调，释放信号，新的一年更强调推动煤炭和新能源优化组合；原料用能不纳入能源消费总量控制；能耗“双控”向碳减排总量和强度“双控”转变。</a></li>
											<li><a href=""  >国家发改委明确加速精细化用能管理，推进能效低于基准水平的重点行业企业有序改造升级。</a></li>
										</ul>
									</div>
								</div>
								<div class="news">
									<div class="news-list">
										<ul>
											<li><a href=""  >3中央经济工作会定调，释放信号，新的一年更强调推动煤炭和新能源优化组合；原料用能不纳入能源消费总量控制；能耗“双控”向碳减排总量和强度“双控”转变。</a></li>
											<li><a href=""  >国家发改委明确加速精细化用能管理，推进能效低于基准水平的重点行业企业有序改造升级。</a></li>
										</ul>
									</div>
									<div class="news-list">
										<ul>
											<li><a href=""  >中央经济工作会定调，释放信号，新的一年更强调推动煤炭和新能源优化组合；原料用能不纳入能源消费总量控制；能耗“双控”向碳减排总量和强度“双控”转变。</a></li>
											<li><a href=""  >国家发改委明确加速精细化用能管理，推进能效低于基准水平的重点行业企业有序改造升级。</a></li>
										</ul>
									</div>
								</div>
								<div class="news">
									<div class="news-list">
										<ul>
											<li><a href=""  >4中央经济工作会定调，释放信号，新的一年更强调推动煤炭和新能源优化组合；原料用能不纳入能源消费总量控制；能耗“双控”向碳减排总量和强度“双控”转变。</a></li>
											<li><a href=""  >国家发改委明确加速精细化用能管理，推进能效低于基准水平的重点行业企业有序改造升级。</a></li>
										</ul>
									</div>
									<div class="news-list">
										<ul>
											<li><a href=""  >中央经济工作会定调，释放信号，新的一年更强调推动煤炭和新能源优化组合；原料用能不纳入能源消费总量控制；能耗“双控”向碳减排总量和强度“双控”转变。</a></li>
											<li><a href=""  >国家发改委明确加速精细化用能管理，推进能效低于基准水平的重点行业企业有序改造升级。</a></li>
										</ul>
									</div>
								</div> -->
							</div>
						</div><!-- /scrNews -->				
						
						
						
						<div class="m_b1"></div>
						
						
						
						<div  class="group1 "><!-- group1 -->
							<div  class="group1_L " ><!-- group1_L -->
								
								<div  class="ZT_banner " ><!-- ZT_banner -->
									<!-- <div class="icon_dingyue" ></div>
									<a href=""><img :src="bannerdata" alt="" style="width: 638px;height: 292px;"/></a> -->
									<a @click="showDingyueDialog()" style="cursor: pointer;" name="D_Subscribe">
										<div class="btn_dingyue" >{{origindingyueList.length>0?'已订阅':'点击订阅'}}</div>
										<img :src="bannerdata" style="width: 638px;height: 292px;" alt=""/>
									</a>
								</div><!-- /ZT_banner -->
								
							</div><!-- /group1_L -->
							<div  class="group1_R  "><!-- group1_R -->
							
									
								<figure class="MyTabs Tabs2"><!-- MyTabs -->
								  <ul class="MyTabs-tabs">
									<li class="MyTabs-tab" :class="hotartType==0?'active':''"><a href="javascript:;" @click="hotartType=0" >专题热点</a></li>
									<li class="MyTabs-tab" :class="hotartType==1?'active':''"><a href="javascript:;" @click="hotartType=1" >推荐阅读</a></li>
								  </ul>
								  <div class="MyTabs-content"><!-- MyTabs-content -->
									<div v-show="hotartType==0" class="MyTabs-pane">
									  	<!-- <el-row class="zhuantireci" style="text-align: center;">
									  		<el-col :span="6" v-for="(item,index) in zhuantireci">
									  			<el-button @click="$router.push({ name: 'theme', params: { searchword: item , pagetype:'1' }})" :title="item">
									  				{{item.length>5?item.substring(0,5)+'...':item}}
									  			</el-button>
									  		</el-col>
									  	</el-row> -->
											<ul  class="ZThot_list"  >
												<li v-for="(item,index) in zhuantireci">
													<a @click="jumppush('/themegj/'+item+'/1?col='+sourcecol)" :title="item" target="_blank">
														{{item}}
													</a>
												</li>
											</ul>
									</div>
									<div v-show="hotartType==1" class="MyTabs-pane">
									  	<ul  class="list1"  >
											<li v-for="item in hotartList"><a @click="jumppush('/detail/'+item.id+'?col='+sourcecol)" target="_blank">{{item.title}}</a></li>
											<!-- <li><a href=""  >国常会决定带量采购“提速扩面”，高值医用耗材纳入集采成趋势</a></li>
											<li><a href=""  >多地密集发布重大项目，新基建与新能源成为重要增长点</a></li>
											<li><a href=""  >IMF警示脆弱新兴经济体：即刻为潜在的经济动荡做准备</a></li>
											<li><a href=""  >刘和平：拜登对华科技战转向“精准脱钩”</a></li> -->
										</ul>
									</div>
								  </div><!-- /MyTabs-content -->
								</figure><!-- /MyTabs -->								
									
	
							</div><!-- /group1_R -->
						</div><!-- /group1 -->
						
						<div class="zhuanti-item-search">
							<itemsearch @showzixunjianyifromsearch="showfankui" v-bind:colid='colid' v-bind:colname='colname' v-bind:colfrom='sourcecol' v-bind:iszhuanti='1' @searchshow="searchshow" @searchclose="searchclose"></itemsearch>
						</div>
						
						<div class="m_b1"></div>
						
						
						<figure v-show="!searchResultShow" class=" Tabs1 " id="zhuantitabs"><!-- MyTabs -->
						
							<div class="HG_sel"><!-- HG_sel -->
								<div class="HG_sel_L">类型</div>
							<div class="HG_sel_R">
								  <ul class="MyTabs-tabs">
										<li @click="ztTabsChange('412a3dff5ff04f35903ca5571f8e50ba',0,0)"
										:class="ztTabsId=='412a3dff5ff04f35903ca5571f8e50ba'?'active':''" class="MyTabs-tab">
											<a href="javascript:;"  >国际快讯</a>
										</li>
										<li @click="ztTabsChange('3e463ebe1a83467384303755288a6cdb',0,0)"
										:class="ztTabsId=='3e463ebe1a83467384303755288a6cdb'?'active':''" class="MyTabs-tab">
											<a href="javascript:;"  >国际政策</a>
										</li>
										<li @click="ztTabsChange('33e4f8e8ad124ee9af18430c582420e3',0,0)"
										:class="ztTabsId=='33e4f8e8ad124ee9af18430c582420e3'?'active':''" class="MyTabs-tab">
											<a href="javascript:;"  >寰球视野</a>
										</li>
										<li @click="ztTabsChange('27e7a33d74c8439aa183ae585c30e6f0',0,0)" 
										:class="ztTabsId=='27e7a33d74c8439aa183ae585c30e6f0'?'active':''" class="MyTabs-tab">
											<a href="javascript:;"  >分析报告</a>
										</li>
										<li @click="ztTabsChange('a350cd3f85294c46a94e713b7ed26494',1,0)"
										:class="ztTabsId=='a350cd3f85294c46a94e713b7ed26494'?'active':''" class="MyTabs-tab">
											<a href="javascript:;"  >最新数据</a>
										</li>
								  </ul>
							</div>
							</div><!-- /HG_sel -->
							
							<div class="HG_sel"><!-- HG_sel -->
								<div class="HG_sel_L">地区</div>
							<div class="HG_sel_R">
								  <ul class="MyTabs-tabs">
										<li @click="ztTabsChange('41277da44c16466bbe41af7ebdeb7685',0,0)"
										:class="ztTabsId=='41277da44c16466bbe41af7ebdeb7685'?'active':''" class="MyTabs-tab">
											<a href="javascript:;"  >全球</a>
										</li>
										<li @click="ztTabsChange('8f694aed476748538ef34e623eacff73',0,0)"
										:class="ztTabsId=='8f694aed476748538ef34e623eacff73'?'active':''" class="MyTabs-tab">
											<a href="javascript:;"  >北美</a>
										</li>
										<li @click="ztTabsChange('318c05046e9d47e290f12513a3a1d87e',0,0)"
										:class="ztTabsId=='318c05046e9d47e290f12513a3a1d87e'?'active':''" class="MyTabs-tab">
											<a href="javascript:;"  >欧盟</a>
										</li>
										<li @click="ztTabsChange('64645e373cf2471a9f424e2a526c8cc3',0,0)"
										:class="ztTabsId=='64645e373cf2471a9f424e2a526c8cc3'?'active':''" class="MyTabs-tab">
											<a href="javascript:;"  >英国</a>
										</li>
										<li @click="ztTabsChange('e7a7ddaedcd84eb6ace18959c09862d7',0,0)"
										:class="ztTabsId=='e7a7ddaedcd84eb6ace18959c09862d7'?'active':''" class="MyTabs-tab">
											<a href="javascript:;"  >日韩</a>
										</li>
										<li @click="ztTabsChange('e5b714e304194131bfc25091a4cc7bef',0,0)"
										:class="ztTabsId=='e5b714e304194131bfc25091a4cc7bef'?'active':''" class="MyTabs-tab">
											<a href="javascript:;"  >东盟</a>
										</li>
										<li @click="ztTabsChange('572620ce804542e6ac65fe118319f375',0,0)"
										:class="ztTabsId=='572620ce804542e6ac65fe118319f375'?'active':''" class="MyTabs-tab">
											<a href="javascript:;"  >新兴经济体</a>
										</li>
										<li @click="ztTabsChange('a97338dd5dfc48b398a702073f4e1718',0,0)"
										:class="ztTabsId=='a97338dd5dfc48b398a702073f4e1718'?'active':''" class="MyTabs-tab">
											<a href="javascript:;"  >其他国际地区</a>
										</li>
								  </ul>
							</div>
							</div><!-- /HG_sel -->

						  <div class="MyTabs-content"><!-- MyTabs-content -->
							<div class="MyTabs-pane"><!-- MyTabs-pane -->
							 
								<template v-if="ztTabsType==0">
									<xwdt v-bind:ztsubid="ztTabsId" v-bind:sourcecol="sourcecol" v-bind:hasPower="hasPower" v-bind:showtype="ztTabsIsShowLabel" v-bind:areacodetag="searchArea"></xwdt>
								</template>
								<template v-else-if="ztTabsType==1">
									<zxsj v-bind:ztsubid="ztTabsId" v-bind:sourcecol="sourcecol" v-bind:hasPower="hasPower" v-bind:zxsjiframeurl="zxsjiframeurl"></zxsj>
								</template>
							 
							 
							</div><!-- /MyTabs-pane -->
						  </div><!-- /MyTabs-content -->
						  
						</figure><!-- /MyTabs -->
						
						
						<div class="m_b1"></div>
	
	
						
	
	
						
						</el-skeleton>
						
						
						
						<div v-show="showdingyue" class="Subscribe_Manage _popRight" id="SubscribeManage_pop" style="display: block;" ><!-- trial_apply -->
							<div class="pop_right"><!-- pop_right -->
								<ul class="pop_right_header2">
									<li><h2>订阅列表</h2></li>
									<li><btn class="pop_right_close2" name="pop-close" @click="cancelDingyuePanel"></btn></li>
								</ul>
								<div class="pop_right_main"><!-- main -->
									
									<div class='form-tips'><h4>订阅栏目后，可在推荐-专题订阅中查看最新数据</h4></div>
									
									<el-checkbox-group v-model="dingyueList">
										<el-checkbox v-for="(item,index) in subcolList" :label="item.columnid">{{item.columnname}}</el-checkbox>
									</el-checkbox-group>
						
									
						
									<div class="m_b1"></div>

								</div><!-- /main -->
								<div class="pop_right_footer2">
										<btn class="s_btn"  @click="saveUserOrders" >确定</btn>
								</div>
							</div><!-- /pop_right -->
							<div class="pop_bg" style="display: block;" @click="cancelDingyuePanel"></div>
						</div><!-- /trial_apply -->
						
						
								
					</div><!-- /Thematic_wrapper -->
					</div>
</template>

<script>
	import zxsj from '@/components/ztsz-zxsj.vue'
	import xwdt from '@/components/ztsz-xwdt.vue'
	import qwsy from '@/components/ztsz-qwsy.vue'
	import itemsearch from '@/components/list-item-search.vue'
	export default {
		data() {
			return {
				hasPower:true,
				loadingMask: false,
				colid:'5091c335c73244df8fde329c7653e8b7',
				colname:'国际经济',
				searchResultShow:false,
				bannerdata:'',
				timer:'',
				sourcecol:'ztguojijingji',
				kanbanPageNo:1,
				kanbanPagePre:1,
				kanbanPageNext:1,
				kanbanPageTotal:1,
				kanbanList:[],
				ztTabsId:'412a3dff5ff04f35903ca5571f8e50ba',
				ztTabsType:0,
				ztTabsIsShowLabel:0,
				searchArea:'',
				searchAreaText:'全部',
				areaPanelVisible:false,
				hotartType:0,
				hotartList:[],
				tjyd:[],
				ztrw:[],
				zhuantireci:[],
				showdingyue:false,
				dingyueList:[],
				origindingyueList:[],
				origindingyuecount:0,
				subcolList:[],
				zxsjiframeurl:window.SITE_CONFIG.gjjjzxsjIframeSrc,
			}
		},
		components: {
			zxsj,
			xwdt,
			qwsy,
			itemsearch,
		},
		created:function(){
			this.bannerfnc();
			this.kanbanfnc();
			this.tuijianfnc();
			// this.rewenfnc();
			this.recifnc();
			this.getAllOrderCol();
		},
		mounted:function(){
			// this.$track();
			document.title='国际经济-中经专网';
			this.$track([
				['pagetype','国际经济专题'],
				['reqtype','2'],
				['column','5091c335c73244df8fde329c7653e8b7']
			]);
			this.$track([
				['pagetype','国际经济专题子栏目'],
				['reqtype','2'],
				['column',this.ztTabsId]
			]);
			// this.timer = setInterval(() => {
			// 	this.nextKBPage();
			// },10000);
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
			document.getElementsByTagName('body')[0].className = 'topbg2';
			this.authcheck();
		},
		destroyed:function(){
			document.getElementsByTagName('body')[0].className = 'topbg1';
		},
		computed: {

		},
		methods: {
			authcheck:function(){
				// this.hasPower=false;
				// if(!this.$cookies.get('userauth')){
				// 	this.hasPower=true;
				// }
				// else{
				// 	if(this.$cookies.get('userauth')=='1921f9e1416473a1d0f15d328e837115'){
				// 		this.hasPower=true;
				// 	}
				// 	if(this.$cookies.get('userauth').indexOf('ztguojijingji')>-1){
				// 		this.hasPower=true;
				// 	}
				// }
			},
			jumppush:function(to){
				this.authcheck();
				if(!this.hasPower){
					alert('您未购买此栏目!');
					return false;
				}
				else{
					var a = document.createElement('a');
					a.setAttribute('href', to);
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a); 
				}
			},
			bannerfnc: function() {
				let _this = this;
				this.$http({
						method: 'get',
						url: 'subject/selecImgtBycolumnID',
						responseType: 'json',
						params: {
							columnID: '5091c335c73244df8fde329c7653e8b7',
						},
					})
					.then(function(response) {
						_this.bannerdata=response.data.data.data.images['5091c335c73244df8fde329c7653e8b7'];
					})
					.catch(function(error) {
						console.log(error);
					});;
			},
			kanbanfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				// this.resultDataList = {};
				// this.totalResultCount = 0;
				this.$http({
						method: 'get',
						url: 'subject/getSubjectColumnArticles',
						responseType: 'json',
						params: {
							columnID: '64915e6c38d940bcbc550698acea9a4b',
							iPage:'1',
							pageSize:'10',
							tagName:'看板',
						},
					})
					.then(function(response) {
						_this.kanbanList = response.data.data.data.data;
						if(_this.kanbanList&&_this.kanbanList.length>0){
							_this.kanbanPageTotal=Math.ceil(_this.kanbanList.length/2);
							_this.changeKBPage();
						}
						_this.loadingMask = false;
					})
					.catch(function(error) {
						console.log(error);
						_this.loadingMask = false;
					});
			},
			tuijianfnc: function() {
				let _this = this;
				this.$http({
						method: 'get',
						url: 'subject/getXZWSubjectHotArticles',
						responseType: 'json',
						params: {
							cName:'国际经济'
							// columnID: 'e2c387dd1ffd414eb70fb703be8f8a7a',
							// iPage:'1',
							// pageSize:'5'
						},
					})
					.then(function(response) {
						_this.hotartList=response.data.data.data;
					})
					.catch(function(error) {
						console.log(error);
					});;
			},
			recifnc: function() {
				let _this = this;
				this.$http({
						method: 'get',
						url: 'subject/searchSubjectHotWord',
						responseType: 'json',
						params: {
							columnID: '55376f1aedc4438180569225a6941fd9',
							pageSize:'12'
						},
					})
					.then(function(response) {
						_this.zhuantireci=response.data.data.data;
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			preKBPage:function(){
				if(this.kanbanPageNo-1<1){
					this.kanbanPageNo=this.kanbanPageTotal;
				}
				else{
					this.kanbanPageNo--;
				}
				this.changeKBPage();
			},
			nextKBPage:function(){
				if(this.kanbanPageNo+1>this.kanbanPageTotal){
					this.kanbanPageNo=1;
				}
				else{
					this.kanbanPageNo++;
				}
				this.changeKBPage();
			},
			changeKBPage:function(){
				this.kanbanPagePre=this.kanbanPageNo-1<1?this.kanbanPageTotal:this.kanbanPageNo-1;
				this.kanbanPageNext=this.kanbanPageNo+1>this.kanbanPageTotal?1:this.kanbanPageNo+1;
			},
			zhuantiColumChange: function() {
			
			},
			ztTabsChange:function(id,type,showlabel){
				// debugger
				this.ztTabsId=id;
				this.ztTabsType=type;
				this.ztTabsIsShowLabel=showlabel;
				this.$track([
					['pagetype','国际经济专题子栏目'],
					['reqtype','2'],
					['column',this.ztTabsId]
				]);
			},
			showDingyueDialog:function(){
				this.showdingyue=true;
				this.$track([
					['pagetype','国际经济专题订阅'],
				]);
			},
			showAreaPanel:function(){
				this.areaPanelVisible=true;
				let _this = this;
				var listenerfunc=function(e){
					if(!document.getElementById('areaPanelDiv').contains(e.target)){
						_this.areaPanelVisible=false;
						document.removeEventListener('click',listenerfunc);
					}
				}
				document.addEventListener('click',listenerfunc)
			},
			areaClick:function(value,name){
				this.searchArea=value;
				this.searchAreaText=name;
				this.areaPanelVisible=false;
			},
			getAllOrderCol:function(){
				let _this = this;
				// _this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'UserInfo/selectAllOrderColByColumnID',
						responseType: 'json',
						params: {
							ColumnID:'5091c335c73244df8fde329c7653e8b7'
						},
					})
					.then(function(response) {
						var tempdata=response.data.data.data;
						var tempchild=[];
						for(var i=0;i<tempdata.length;i++){
							if(tempdata[i].Child&&tempdata[i].Child.length>0){
								for(var j=0;j<tempdata[i].Child.length;j++){
									tempdata[i].Child[j].columnname=tempdata[i].columnname+'-'+tempdata[i].Child[j].columnname;
								}
								tempchild=tempchild.concat(tempdata[i].Child);
							}
						}
						if(tempchild.length>0){
							tempdata=tempchild;
						}
						var dingyuedata=tempdata;
						_this.origindingyueList=[];
						_this.origindingyuecount=0;
						for(var i=0;i<dingyuedata.length;i++){
							if(dingyuedata[i].ordertype=="1"){
								_this.origindingyueList.push(dingyuedata[i].columnid);
							}
						}
						_this.dingyueList = JSON.parse(JSON.stringify(_this.origindingyueList));
						_this.subcolList = dingyuedata;
						// _this.loadingMask = false;
					})
					.catch(function(error) {
						// _this.loadingMask = false;
						console.log(error);
					});
			},
			saveUserOrders:function(){
				var colidstring=this.dingyueList.join(',');
				let _this = this;
				// _this.loadingMask = true;
				this.$http({
						method: 'post',
						url: 'UserInfo/SaveUserColOrders',
						responseType: 'json',
						params: {
							rootColID:'5091c335c73244df8fde329c7653e8b7',
							strColID:colidstring
						},
					})
					.then(function(response) {
						if(response.data.data.data.code=='0'){
							_this.$track([
								['pagetype','订阅修改'],
								['reqtype','3'],
								['column',_this.dingyueList.join(' ')]
							]);
							_this.$message({
								message: '订阅修改成功',
								type: 'success'
							});
							_this.showdingyue=false;
							_this.getAllOrderCol();
						}
						// _this.loadingMask = false;
					})
					.catch(function(error) {
						// _this.loadingMask = false;
						console.log(error);
					});
			},
			cancelDingyuePanel:function(){
				this.showdingyue=false;
				this.dingyueList = JSON.parse(JSON.stringify(this.origindingyueList));
				// for(var i=0;i<this.origindingyueList.length;i++){
				// 	this.$set(this.dingyueList[i],'selected',this.origindingyueList[i].selected);
				// }
				// console.log(this.dingyueList);
			},
			searchshow:function(key){
				this.searchResultShow=true;
			},
			searchclose:function(){
				this.searchResultShow=false;
			},
			showfankui:function(){
				this.$emit('showzixunjianyifromsearch');
			}
		}
	}
</script>

<style>
	
</style>
